import { Container } from "@mui/material";

import NavigationToggle from "@/features/admin/components/navigation-toggle/NavigationToggle";
import AvatarCard, {
  AvatarCardType,
} from "@/features/shared/components/avatar-card/avatar-card";
import { useExtranetsQuery } from "@/features/admin/hooks";
import Fluid from "@/components/fluid/fluid";

const ExtranetsOverviewPage = () => {
  const { data: extranets } = useExtranetsQuery();

  return (
    <Container sx={{ mt: { xs: 2, md: 6 } }}>
      <NavigationToggle />

      <Fluid width={280} spacing={4}>
        {extranets?.map((extranet) => (
          <AvatarCard
            key={extranet.id}
            name={extranet.name}
            to={"/admin/extranets/" + extranet.id}
            type={AvatarCardType.DASHBOARD}
          />
        ))}
      </Fluid>
    </Container>
  );
};

export default ExtranetsOverviewPage;
